import type { OrderStatus } from "@the-drop/types";
import { fetchWithClerkJwt } from "./fetch-with-clerk";

export type CustomerOrderListItem = {
  id: string;
  status: OrderStatus;
  totalCents: number;
  createdAt: string;
  dispensary: {
    displayName: string;
    publicSlug: string | null;
  };
};

export type CustomerOrdersListResponse = {
  orders: CustomerOrderListItem[];
};

export async function fetchCustomerOrders(
  getToken: () => Promise<string | null>,
  opts?: { limit?: number; offset?: number },
): Promise<CustomerOrdersListResponse> {
  const limit = opts?.limit ?? 50;
  const offset = opts?.offset ?? 0;
  const qs = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  const res = await fetchWithClerkJwt(getToken, `/api/v1/orders?${qs.toString()}`);
  if (!res.ok) {
    throw new Error(`orders_list_http_${res.status}`);
  }
  return (await res.json()) as CustomerOrdersListResponse;
}
